export default __webpack_public_path__ + "static/media/sms.4cb7b6e4.svg";